import React from 'react';
import { translate } from '../../Services/translation';

const SizeRelationSection = (props) => {
  const relatatedProductHasConfigurator = !props.hasConfigurator;
  return (
    <>
      <div className="[ size-relation__heading ] [ text-medium bold text-grey-900 bold lh-2 ]">
        {relatatedProductHasConfigurator
          ? translate('size-relation.heading-as-fixed-size')
          : translate('size-relation.heading-as-custom-size')}
      </div>
      <a
        href={props.url}
        className="product-page__size-relation size-relation"
        rel="noreferrer"
      >
        {(props.imageUrl || props.images) && (
          <div className="size-relation__image-wrapper">
            <img alt="" src={props.imageUrl ?? props.images[0]} />
          </div>
        )}
        <div className="size-relation__content-wrapper color-grey-900">
          <div className="[ size-relation__title ] [ text-small color-grey-900 lh-1 bold ]">
            {props.name}
          </div>
          <div className="[ size-relation__category ] [ text-xsmall color-grey-500 ]">
            {props.category}
          </div>
          <div className="[ size-relation__price ][ text-small color-grey-900 lh-1 bold ]">
            {translate('size-relation.from')} {props.lowestPriceWithCurrency}
          </div>
        </div>
        <div className="size-relation__icon-wrapper">
          <i className="ph-arrow-square-out"></i>
        </div>
      </a>
    </>
  );
};

export default SizeRelationSection;
